export function trackPage(page: string) {
    ga('send', {
        hitType: 'pageview',
        page,
    });
}
